import { render, staticRenderFns } from "./CommentSet.vue?vue&type=template&id=3b69f2d7&scoped=true"
import script from "./CommentSet.vue?vue&type=script&lang=js"
export * from "./CommentSet.vue?vue&type=script&lang=js"
import style0 from "./CommentSet.vue?vue&type=style&index=0&id=3b69f2d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b69f2d7",
  null
  
)

export default component.exports